import React, { useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { IndicatorPanel } from './IndicatorsPanels'
import useActions from 'utils/customHook/useActions'
import { Grid2 } from '@mui/material'
import StatusPanel from './StatusPanel'
import EntityForm from './EntityForm'
import { getYear } from 'utils/DateUtil'
import UpdateEntityPanel from '../collectivity/UpdateEntityPanel'

const ManagementEntityDasboardApp = () => {
    const {
        collectivity,
        managementEntityProps,
    } = useSelector(store => ({
        collectivity: store.CollectivityReducer.collectivity,
        managementEntityProps: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const { collectivityId, entityId } = useParams()

    const [managementEntity, setManagementEntity ] = useState(managementEntityProps)
    const [readMode, setReadMode] = useState(true)

    useEffect(() => {
        setManagementEntity(managementEntityProps)
    }, [managementEntityProps])

    useTitle(() => [{
        title: 'RPQS',
        href: 'rpqs',
    }, {
        title: getYear(collectivity.dateEnd) || `${i18n.year} ${i18n.unknown}`,
        href: 'rpqs',
    }, {
        title: collectivity.name || `${i18n.collectivity} ${i18n.unknown}`,
        href: `collectivity/rpqs/${collectivityId}`,
    }, {
        title: managementEntityProps.name || `${i18n.managementEntity} ${i18n.unknown}`,
        href: `rpqs/collectivity/${collectivityId}/entity/${entityId}`,
    }], [collectivity, managementEntityProps, collectivityId, entityId])

    useActions(() => {
        if (readMode) {
            return {
                import: () => {},
                delete: () => {},
                export: () => {},
                edit: () => setReadMode(false),
            }
        }
        return {
            cancel: () => {
                setManagementEntity(managementEntityProps)
                setReadMode(true)
            },
            save: () => {
                setReadMode(true)
            },
        }
    }, [readMode])

    return (
        <div style={{ padding: '1rem' }}>
            <Grid2 container direction={'column'} rowSpacing={2}>
                <Grid2 container columnSpacing={2}>
                    <Grid2 size={9}>
                        <EntityForm
                            readMode={readMode}
                            setEntity={setManagementEntity}
                            entity={managementEntity}
                        />
                    </Grid2>
                    <Grid2
                        container
                        direction={'column'}
                        size={3}
                    >
                        <StatusPanel
                            status={managementEntity?.[getYear(managementEntity?.dateEnd)]?.status}
                        />
                        <UpdateEntityPanel
                            updateDate={managementEntity?.updateDate}
                            updateLogin={managementEntity?.updateLogin}
                            entityName={managementEntity?.name}
                        />
                    </Grid2>
                </Grid2>
                <IndicatorPanel
                    managementEntity={managementEntity}
                />
            </Grid2>
        </div>
    )
}

export default ManagementEntityDasboardApp
